// extracted by mini-css-extract-plugin
module.exports = {"openModalBtn":"ChangeClinic_openModalBtn__OCtDz","footer":"ChangeClinic_footer__v6a8B"};